<template>
  <div>
    <div class="number-of-candidates">
      <div class="potential-candidates alert alert-info">
        <span><strong>{{ candidatesCount }}</strong> {{ $t("candidate.potential_candidates") }}</span>
      </div>
      <div class="selected-candidates alert alert-success">
        <span><strong>{{ selectedCandidates }}</strong> {{ $t("candidate.selected_candidates")  }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 p-b-15">
        <div class="input-group">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="pg-search"></i>
            </span>
            <input @input="typingInput"
                  :placeholder="$t('users.search.recherche_name')"
                  class="form-control search-users-input"
                  v-model="searchInput">
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 p-b-15">
        <div class="row">
          <div class="col-3 text-right">
            <label for="affiliated_service_id_in" class="control-label label-input-filter">
              {{ $t("Offers.filters.services_replace") }}
            </label>
          </div>
          <div class="col-9">
            <multiselect id="affiliated_service_id_in"  v-model="filters_display.affiliated_service_id_in"
                        label="name"
                        track-by="id"
                        @input="addFilterId"
                        :group-label="entityHasHubs ? 'hub' : ''"
                        :group-values="entityHasHubs ? 'services' : ''"
                        :showLabels="false"
                        :multiple="true"
                        :placeholder="$t('multiselect.placeholder')"
                        :options="servicesOptions"/>
          </div>
        </div>
      </div>
    </div>

    <table class="table table-hover table-hover-pink table-candidate table-homepage">
      <thead>
        <tr>
          <th class="text-left">{{ $t('table.headers.candidates') }}</th>
          <th class="text-left">{{ $t('table.headers.connecting_service') }}</th>
          <th class="number-info" @click="sortByColumn('week')">
            {{ $t('table.headers.week') }}
            <i v-if="sortColumn === 'week'" class="fa" :class="sortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i>
          </th>
          <th class="number-info" @click="sortByColumn('month')">
            {{ $t('table.headers.accumulation_of_hours') }}
            <i v-if="sortColumn === 'month'" class="fa" :class="sortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i>
          </th>
          <th class="number-info" @click="sortByColumn('year')">
            {{ $t('table.headers.year') }}
            <i v-if="sortColumn === 'year'" class="fa" :class="sortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i>
          </th>
          <th><input type="checkbox" id="checkbox-all" v-model="checkAll" @input="updateAllCheckBox"></th>
        </tr>
      </thead>
      <tbody class="alternating-rows">
        <candidate-row v-for="candidate in potentialCandidates.data"
                      :key="candidate.id"
                      :candidate="candidate"
                      :checkAllCandidates="checkAllCandidates"
                      :checkCandidateIds = "checkedCandidatesList"
                      @updateCheckedValue="updatePotentialCandidatesList"
                      :entityId="entityId"/>
      </tbody>
    </table>

    <paginate v-if="totalPages > 1"
              :page-count="parseInt(totalPages)"
              :click-handler="pageChanged"
              :container-class="'pagination m-t-15'"
              :page-class="'page-item'"
              :hide-prev-next="true"
              :prev-text="$t('pagination.previous')"
              :next-text="$t('pagination.next')"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import CandidateRow from './CandidateRow'
  import Paginate from 'vuejs-paginate'
  import _ from 'lodash';

  export default {
    name: 'SelectCandidates',
    props: ['candidatesCount', 'offer', 'isSingle', 'entityId'],
    components: { Paginate, CandidateRow },
    data: function() {
      return {
        checkAll: true,
        checkAllCandidates: true,
        selectedCandidates: 0,
        searchInput: '',
        sortColumn: null,
        sortDirection: 'asc'
      }
    },
    computed: {
      ...mapGetters({
        page: 'offers/candidatesListPage',
        currentUser: 'auth/currentUser',
        potentialCandidatesIds: 'offers/candidatesIdsList',
        potentialCandidates: 'offers/candidatesList',
        checkedCandidatesList: 'offers/checkedCandidatesList',
        manageableEntities: 'users/manageableEntities',
        manageableServices: 'users/manageableServices',
        filters_display: 'stats/filters_display'
      }),
      totalPages() {
        return this.potentialCandidates.totalPages
      },
      servicesOptions() {
        if (!this.entityHasHubs) {
          return this.manageableServices;
        }
        return this.buildServicesListGroupedByHubs();
      },
      availableHubs() {
        if(this.selectedEntityId) {
          return this.currentUser.hubs.filter((hub) => hub.entity_id == this.selectedEntityId);
        }
        return this.currentUser.hubs;
      },
    },
    watch: {
      candidatesCount(newValue,_) {
        if (newValue == 0) {
          this.selectedCandidates = 0
          this.$emit('selectedCandidates', this.selectedCandidates)
        }
      }
    },
    methods: {
      ...mapActions({
        updateCheckedCandidatesList: 'offers/updateCheckedCandidatesList',
        resetCheckedCandidatesList: 'offers/resetCheckedCandidatesList',
        searchPotentialCandidates: 'offers/searchPotentialCandidates'
      }),
      addFilterId: function (values, id) {
        let value = values.map((value) => value.id);
        let result = {id: id, value: value}
        if (value.length === 0) {
          this.filters_display.affiliated_service_id_in = ''
        } else if ('is_fake' in values[0]) {
          this.filters_display.affiliated_service_id_in = ''
        }
        this.filter()
      },
      typingInput: _.debounce(function(e) {
        this.searchInput = e.target.value
        this.filter()
      }, 250),
      filter() {
        this.searchPotentialCandidates({ searchWord: this.searchInput,
                                         replacedServices: [],
                                         affiliatedServices: this.filters_display.affiliated_service_id_in,
                                         params: this.offerPotentialCandidateParams() });
      },
      updatePotentialCandidatesList: function(candidate) {
        this.updateCheckedCandidatesList({candidateId: candidate.userId, checked: candidate.checked})

        if (candidate.checked) {
          this.selectedCandidates++
        } else {
          this.selectedCandidates--
        }

        this.$emit('selectedCandidates', this.selectedCandidates)

        this.checkboxAllCandidates()

        this.$emit('updateCheckedValue', this.checkedCandidatesList)
      },
      pageChanged: function(page) {
        this.$emit('pageChanged', page)
      },
      updateAllCheckBox() {
        this.checkAll = !this.checkAll

        if (this.checkAll) {
          this.updateAllCheckedCandidatesIds(true)
          this.selectedCandidates = Object.values(this.checkedCandidatesList).length
        } else {
          this.updateAllCheckedCandidatesIds(false)
          this.selectedCandidates = 0
        }

        this.$emit('selectedCandidates', this.selectedCandidates)

        this.checkAllCandidates = !this.checkAllCandidates
        this.$emit('updateCheckedValue', this.checkedCandidatesList)
      },
      updateAllCheckedCandidatesIds(value) {
        Object.keys(this.potentialCandidatesIds).forEach((id) => {
          this.updateCheckedCandidatesList({candidateId: id, checked: value})
        })
      },
      countCandidates() {
        this.selectedCandidates = 0
        Object.keys(this.potentialCandidatesIds).forEach((id) => {
          if (this.potentialCandidatesIds[id]) {
            this.selectedCandidates++
          }
          if (this.checkedCandidatesList[id] != undefined && !this.checkedCandidatesList[id]) {
            this.selectedCandidates--
          }
        })
        this.$emit('selectedCandidates', this.selectedCandidates)
      },
      checkboxAllCandidates() {
        if (this.selectedCandidates == this.candidatesCount) {
          this.checkAll = true
        } else {
          this.checkAll = false
        }
      },
      offerPotentialCandidateParams(){
        let entityId
        if (this.isSingle && this.manageableEntities[0]) {
          entityId = this.manageableEntities[0].id
        } else {
          entityId = this.offer.entity.id
        }
        return {
          id: this.offer.id,
          resource_type: this.offer.resource_type,
          mode: this.offer.mode,
          replaced_service_id: this.offer.replaced_service.id,
          searched_occupation_ids: this.offer.searched_occupations.map(occupation => occupation.id),
          offer_periods_attributes: this.offer.offer_periods_attributes,
          include_proposed_candidates: this.offer.include_proposed_candidates,
          include_hub_services: this.offer.include_hub_services,
          entity_id: entityId
        }
      },
      entityHasHubs() {
        return this.offer.entity.hubs.length > 1
      },
      buildServicesListGroupedByHubs() {
        return this.availableHubs.map(hub => {
          return {
            hub: hub.name,
            services: this.manageableServices.filter(service => service.hub_id == hub.id)
          }
        });
      },
      sortByColumn(column) {
        if (this.sortColumn === column) {
          this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
          this.sortColumn = column;
          this.sortDirection = 'asc';
        }

        this.sortCandidates();
      },
      sortCandidates() {
        if (this.sortColumn) {
          this.potentialCandidates.data.sort((a, b) => {
            return this.sortDirection === 'asc' ? a.effective_work_minutes[this.sortColumn] - b.effective_work_minutes[this.sortColumn] :
                                                  b.effective_work_minutes[this.sortColumn] - a.effective_work_minutes[this.sortColumn]
          });
        }
      },
    },
    mounted() {
      this.countCandidates()
      this.checkboxAllCandidates()
      this.resetCheckedCandidatesList()
    },
    destroyed() {
      this.resetCheckedCandidatesList()
    }
  }
</script>

<style lang="scss" scoped>
  .table thead tr th {
    padding: 16px;
  }
  .number-of-candidates {
    margin: 25px 0;
    display: flex;
    justify-content: space-around;
  }
  .potential-candidates , .selected-candidates {
    font-size: 16px;
    padding: 16px 32px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border-radius: 2px;
  }

  .number-info {
    background-color: #eff9f7;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/SelectCandidates.vue